import { PURGE } from 'redux-persist';

const initialState = {
  phoneId: '',
  allPhones: null,  // Changed from [] to null to differentiate "not loaded" vs "empty"
  allCallLogs: [],
  loading: false,
  phonesLoading: false,
  callLogsLoading: false,
  phonesFetched: false,  // Added to track if phones have been fetched
  twilioVoiceToken: null,  // Twilio Voice access token
  twilioPhoneNumber: null,  // Twilio phone number for caller ID
  twilioError: null,  // Error message for Twilio integration issues
  pendingCall: null,  // { phone, contact, justOpenDialpad } - for triggering calls from anywhere
  dialpadVisible: false,  // Dialpad visibility - persists across page navigation (like Milo)
  softphoneContacts: null,  // Separate contacts state for softphone (prevents main page re-render)
  softphoneCallLogs: null,  // Separate call logs state for softphone (prevents main page re-render)
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case PURGE:
      return initialState;

    case 'GET_ALL_PHONES':
      return { ...state, loading: true, phonesLoading: true };

    case 'GET_CALL_LOGS':
      return { ...state, loading: true, callLogsLoading: true };

    // —— Phone Reducers —— //
    case 'SET_ALL_PHONES':
      return {
        ...state,
        allPhones: payload || [],
        loading: false,
        phonesLoading: false,
        phonesFetched: true
      };

    // —— CallLog Reducers —— //
    case 'SET_CALL_LOGS':
      return {...state, allCallLogs: payload, loading: false, callLogsLoading: false};

    // —— Phone Reducers —— //
    case 'SET_PHONE_ID':
      return { ...state, phoneId: payload };

    // —— Twilio Voice Reducers —— //
    case 'SET_TWILIO_VOICE_TOKEN':
      return {
        ...state,
        twilioVoiceToken: payload?.token || null,
        twilioPhoneNumber: payload?.phoneNumber || null,
        twilioError: payload?.error || null
      };

    // —— Softphone Reducers —— //
    case 'OPEN_SOFTPHONE_AND_CALL':
      return { ...state, pendingCall: payload };

    case 'CLEAR_PENDING_CALL':
      return { ...state, pendingCall: null };

    // —— Dialpad Visibility —— //
    case 'SET_DIALPAD_VISIBLE':
      return { ...state, dialpadVisible: payload };

    // —— Softphone Contacts (separate from main page) —— //
    case 'SET_SOFTPHONE_CONTACTS':
      const isAppendingContacts = payload?.page && payload.page > 1;
      const existingContacts = state.softphoneContacts?.records || [];
      const newContacts = payload?.records || [];
      return { ...state, softphoneContacts: { ...payload, records: isAppendingContacts ? [...existingContacts, ...newContacts] : newContacts } };

    // —— Softphone Call Logs (separate from main page) —— //
    case 'SET_SOFTPHONE_CALL_LOGS':
      const isAppendingCallLogs = payload?.page && payload.page > 1;
      const existingCallLogs = state.softphoneCallLogs?.callLogs || [];
      const newCallLogs = payload?.callLogs || [];
      return { ...state, softphoneCallLogs: { ...payload, callLogs: isAppendingCallLogs ? [...existingCallLogs, ...newCallLogs] : newCallLogs } };

    default:
      return state;
  }
}